import type { ColumnSettings } from "metabase-types/api";

import { getUrlProtocol } from "./url";

export function formatImage(
  value: string,
  { jsx, rich, view_as = "auto", column_title }: ColumnSettings = {},
) {
  const url = String(value);
  const protocol = getUrlProtocol(url);
  const acceptedProtocol = protocol === "http:" || protocol === "https:";
  if (jsx && rich && view_as === "image" && acceptedProtocol) {
    // column_title (when the column has a display name configured) is the
    // best available description of what this data-driven image shows;
    // fall back to decorative (empty alt) rather than leave it unset.
    return <img src={url} alt={column_title ?? ""} style={{ height: 30 }} />;
  } else {
    return url;
  }
}
